import { Dispatch, useEffect, useState } from "react";
import { useColors } from "../../../../../hooks/colors/useColors";
import { useTranslation } from "next-i18next";
import { bookingStore } from "../../../../config/store/bookingStore";
import { localServerUrl } from "../../../../../constants/env";
import { useAppointment } from "../useAppointment";
import { useUser } from "../../../../../hooks/react-query/useUser";
import { PaymentMethod, usePayment } from "./usePayment";
import { PaymentForm } from "./PaymentForm";

export default function PaymentOptions(props: {
  setProcessing: Dispatch<boolean>;
  processing: boolean;
}) {
  const { processing, setProcessing } = props;
  const { paymentOptions } = usePayment();
  const [selected, setSelected] = useState<PaymentMethod>(paymentOptions[0]);
  const {
    bookingForm,
    prepaymentStep,
    setPrepaymentStep,
    amount,
    updateBookingForm,
  } = bookingStore((state) => state);
  const { i18n } = useTranslation("common");
  const { submitBooking } = useAppointment();
  const { user } = useUser();
  const [phone, setPhone] = useState<string>("");

  useEffect(() => {
    if (user) {
      if (user.user?.phoneNumber) {
        setPhone(user.user.phoneNumber);
      }
    }
  }, [user]);

  async function submitForm() {
    if (bookingForm) {
      if (selected.name === "Multibanco") {
        bookingForm.paymentRequest = {
          paymentMethod: "MULTIBANCO",
        };

        updateBookingForm(bookingForm);
        await submitBooking(bookingForm, setProcessing);
      } else if (selected.name === "MB WAY") {
        bookingForm.paymentRequest = {
          paymentMethod: "MBWAY",
          phoneNumber: phone,
        };
        updateBookingForm(bookingForm);
        await submitBooking(bookingForm, setProcessing);
      }
      // } else {
      //   bookingForm.paymentRequest = {
      //     paymentMethod: "CREDIT_CARD",
      //     language: i18n.language,
      //     successUrl: `${localServerUrl}/user/payment/itp/success`,
      //     errorUrl: `${localServerUrl}/user/payment/itp/error`,
      //     cancelUrl: `${localServerUrl}/user/payment/itp/cancel`,
      //   };
      //   updateBookingForm(bookingForm);
      //   await submitBooking(bookingForm, setProcessing);
      // }
    }
  }

  function closeModal() {
    setPrepaymentStep(false);
  }

  return (
    <PaymentForm
      opened={typeof prepaymentStep !== "undefined" && prepaymentStep}
      closeModal={closeModal}
      selected={selected}
      setSelected={setSelected}
      phone={phone}
      setPhone={setPhone}
      submitForm={submitForm}
      processing={processing}
      amount={amount}
    />
  );
}
